import sharedModule from '../../shared.module';

class HttpUtil {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    get(url, config) {
        return this.http('GET', url, undefined, config);
    }

    post(url, body, config) {
        return this.http('POST', url, body, config);
    }

    http(method, url, body, config) {
        if (!method || !url) {
            return this.$q.reject('invalidParameters');
        }

        var deferred = this.$q.defer();

        this.$http({
            method: method,
            url: url,
            data: body,
            ...config
        }).then(
            response => deferred.resolve(response.data),
            response => deferred.reject(response.data)
        );

        return deferred.promise;
    }
}

export default sharedModule.service('httpUtil', HttpUtil);



// WEBPACK FOOTER //
// ./modules/shared/services/httpUtil/httpUtil.service.js